'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _UIAlert = require('UIComponents/alert/UIAlert');

var _UIAlert2 = _interopRequireDefault(_UIAlert);

var _FormattedMessage = require('I18n/components/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _parcelUtils = require('self-service-api/core/utilities/parcelUtils');

var _settingsApi = require('self-service-api/core/api/settingsApi');

var _PartnerProgramSelectors = require('pricing-pages-unified-ui/selectors/PartnerProgramSelectors');

var _SettingsSelectors = require('pricing-pages-unified-ui/selectors/SettingsSelectors');

var _getUsageTracker = require('pricing-pages-unified-ui/utils/getUsageTracker');

var _getUsageTracker2 = _interopRequireDefault(_getUsageTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';

var PartnerProgramBanner = function (_Component) {
  _inherits(PartnerProgramBanner, _Component);

  function PartnerProgramBanner(props) {
    _classCallCheck(this, PartnerProgramBanner);

    var _this = _possibleConstructorReturn(this, (PartnerProgramBanner.__proto__ || Object.getPrototypeOf(PartnerProgramBanner)).call(this, props));

    _this.state = { shouldShowBanner: false };
    _this.closeBanner = _this.closeBanner.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(PartnerProgramBanner, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.isMounted_ = true;
      var _props = this.props,
          isPartnerProgramEligible = _props.isPartnerProgramEligible,
          isBannerDismissed = _props.isBannerDismissed;


      (0, _parcelUtils.isPaidHub)().then(function (hasPaidProduct) {
        if (!_this2.isMounted_) return;
        var shouldShowBanner = isPartnerProgramEligible && !hasPaidProduct && !isBannerDismissed;

        _this2.setState({ shouldShowBanner: shouldShowBanner });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isMounted_ = false;
    }
  }, {
    key: 'closeBanner',
    value: function closeBanner() {
      this.setState({ shouldShowBanner: false });
      (0, _settingsApi.setSetting)(BANNER_DISMISSED_KEY, true);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      (0, _getUsageTracker2.default)().track('externalLinkClick', {
        name: 'partner-banner-more-info'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var shouldShowBanner = this.state.shouldShowBanner;


      if (!shouldShowBanner) return null;

      return _react2.default.createElement(
        _UIAlert2.default,
        {
          type: 'info',
          className: 'm-bottom-4',
          closeable: true,
          onClose: this.closeBanner,
          titleText: _react2.default.createElement(_FormattedMessage2.default, { message: 'pricingPage.promotions.partnerProgram.title' })
        },
        _react2.default.createElement(_FormattedHTMLMessage2.default, {
          message: 'pricingPage.promotions.partnerProgram.text',
          onClick: this.handleClick
        })
      );
    }
  }]);

  return PartnerProgramBanner;
}(_react.Component);

PartnerProgramBanner.propTypes = {
  isPartnerProgramEligible: _react.PropTypes.bool.isRequired,
  isBannerDismissed: _react.PropTypes.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isPartnerProgramEligible: (0, _PartnerProgramSelectors.isPartnerProgramEligibleSelector)(state),
    isBannerDismissed: (0, _SettingsSelectors.settingsValueSelector)(state, BANNER_DISMISSED_KEY)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(PartnerProgramBanner);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/banners/PartnerProgramBanner.js
// module id = 726
// module chunks = 3 4